import React from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField,
  Typography,
  Paper,
  Button,
  StepContent,
  StepLabel,
  Step,
  Stepper,
  StepConnector,
} from '@material-ui/core';


const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginBottom: theme.spacing.unit * 2,
  },
  resetContainer: {
    padding: theme.spacing.unit * 3,
  },
});

class MsStepperLocation extends React.Component {

  static propTypes = {

    data: PropTypes.data,

  };

  static defaultProps = {

    answers: false,

  };

  constructor(props) {

    super(props);

    this.state = {
      activeStep: 0,
      lstExecution: {},
      wfsteps: {},
    };

  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.data.lstExecution && nextProps.data.lstExecution.length > 0)
      this.setState({ activeStep: nextProps.data.lstExecution.length });

  }

  shouldRender = () =>
    this.props.data.wfsteps && this.props.data.wfsteps.length > 0


  shouldRenderAnswers(index) {

    const { data } = this.props;
    let answer = [];

    if (data.lstExecution[index] && data.lstExecution[index].formResult !== '')
      answer = JSON.parse(data.lstExecution[index].formResult);


    return (
      answer && answer.length > 0 && answer.map(ans => (
        <Typography>
          {ans.FieldName}: {ans.Answer}
        </Typography>
      ))
    );

  }

  handleNext = () => {

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));

  };

  handleBack = () => {

    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));

  };

  render() {

    const { classes, data, answers } = this.props;
    const { activeStep } = this.state;

    return (
      this.shouldRender() && <div className={classes.root}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {data.wfsteps.map((step, index) => (
            <Step key={index}>
              <StepLabel>{step.name}</StepLabel>
              <StepContent>
                {answers && this.shouldRenderAnswers(index)}
                <div className={classes.actionsContainer}>
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={this.handleBack}
                      className={classes.button}
                    >
                      { I18n.t('button.previous') }
                    </Button>
                    <Button
                      disabled={activeStep === data.lstExecution.length}
                      variant="contained"
                      color="primary"
                      onClick={this.handleNext}
                      className={classes.button}
                    >
                      {activeStep === data.wfsteps.length - 1 ? `${I18n.t('button.finish')} ` : `${I18n.t('button.next')}` }
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {activeStep === data.wfsteps.length && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography>Nota Finalizada !</Typography>
          </Paper>
        )}
      </div>
    );

  }
}

MsStepperLocation.propTypes = {
  classes: PropTypes.style,
};

export default withStyles(styles)(MsStepperLocation);



// WEBPACK FOOTER //
// ./src/components/tracker/Check/MsStepperLocation.js